import React from "react";
import { Container } from "react-bootstrap";

const StobocloHCP = ({ shouldHideDiv, collapseText, isiTextRef, readLess }) => {
  return (
    <>
      <div
        className={`isi-text-sticky isi-text ${shouldHideDiv ? "d-none" : ""}`}
      >
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex" style={{ display: "flex" }}>
            <button className="isi-text-open open" onClick={collapseText}>
              
            </button>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="stoboclo-color">
                  IMPORTANT SAFETY INFORMATION
                </strong>
              </p>
              <p>
                If you receive Stoboclo, you should not receive other denosumab
                products at the same time.
              </p>
              <p>
                <strong>
                  Stoboclo can cause serious side effects including:
                </strong>
              </p>
              <p>
                <strong>
                  Increased risk of severe low calcium levels in your blood
                  (hypocalcemia).
                </strong>
                &nbsp; Stoboclo may lower the calcium levels in your blood. Your
                doctor should treat any low calcium levels before starting
                Stoboclo and may prescribe calcium and vitamin D
                supplements—take these exactly as instructed. If you have
                advanced chronic kidney disease (with or without dialysis) or
                chronic kidney disease-mineral bone disorder (CKD-MBD), your
                risk of severe hypocalcemia increases, potentially leading to
                hospitalization, life-threatening events, or death. Your doctor
                may monitor your blood levels before and during treatment. Low
                blood calcium often has no symptoms, but call your doctor
                immediately if you notice muscle spasms, twitches, cramps, or
                numbness and tingling in your fingers, toes, or around your
                mouth.
              </p>
            </div>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="stoboclo-color">INDICATIONS</strong>
              </p>
              <p>
                Stoboclo (denosumab-bmwo) is a prescription medicine used to:
                <ul>
                  <li>
                    Treat osteoporosis in women after menopause who are at high
                    risk for fracture or who cannot use or haven’t responded
                    well to other osteoporosis medicines.
                  </li>
                  <li>
                    Increase bone mass in men with osteoporosis who are at high
                    risk for fracture.
                  </li>
                  <li>
                    Treat osteoporosis in men and women who will be taking
                    corticosteroid medicines (such as prednisone) for at least 6
                    months and are at high risk for fracture.
                  </li>
                  <li>
                    Treat bone loss in men who are at high risk for fracture
                    receiving certain treatments for prostate cancer that has
                    not spread to other parts of the body.
                  </li>
                  <li>
                    Treat bone loss in women who are at high risk for fracture
                    receiving certain treatments for breast cancer that has not
                    spread to other parts of the body.
                  </li>
                </ul>
                It is not known if Stoboclo is safe and effective in children.
                Stoboclo is not approved for use in children.
              </p>
            </div>
          </div>
        </Container>
      </div>

      <div className="isi-text" ref={isiTextRef}>
        <Container className="position-relative">
          <div className="isi-text-wrap responsive-flex" style={{ display: "flex" }}>
            <button onClick={readLess} className="isi-text-open closed">
              
            </button>
            <div style={{paddingRight:"40px"}}>            
            <br />
            <p>
              <strong className="stoboclo-color">
                IMPORTANT SAFETY INFORMATION
              </strong>
            </p>
            <p>
              If you receive Stoboclo, you should not receive other denosumab
              products at the same time.
            </p>
            <p>
              <strong>
                Stoboclo can cause serious side effects including:
              </strong>
            </p>
            <p>
              <strong>
                Increased risk of severe low calcium levels in your blood
                (hypocalcemia).
              </strong>
              &nbsp; Stoboclo may lower the calcium levels in your blood. Your
              doctor should treat any low calcium levels before starting
              Stoboclo and may prescribe calcium and vitamin D supplements—take
              these exactly as instructed. If you have advanced chronic kidney
              disease (with or without dialysis) or chronic kidney
              disease-mineral bone disorder (CKD-MBD), your risk of severe
              hypocalcemia increases, potentially leading to hospitalization,
              life-threatening events, or death. Your doctor may monitor your
              blood levels before and during treatment. Low blood calcium often
              has no symptoms, but call your doctor immediately if you notice
              muscle spasms, twitches, cramps, or numbness and tingling in your
              fingers, toes, or around your mouth.
            </p>
            <p>
              <strong>Serious allergic reactions.</strong> Serious allergic
              reactions have occurred with denosumab products. Call your doctor
              or seek emergency care immediately if you experience symptoms such
              as low blood pressure (hypotension), rash, difficulty breathing,
              itching, throat tightness, hives, or swelling of your face, lips,
              or tongue.
            </p>
            <p>
              <strong>Severe jawbone problems (osteonecrosis).</strong> Severe
              jaw bone problems may happen when you take Stoboclo. Your doctor
              should examine your mouth before starting treatment and may advise
              seeing a dentist. Practice good oral care and consult your doctor
              or dentist if needed.
            </p>
            <p>
              <strong>Unusual thigh bone fractures.</strong> Symptoms include
              new or unusual pain in your hip, groin, or thigh.{" "}
            </p>
            <p>
              <strong>
                Increased risk of broken bones, including broken bones in the
                spine, after stopping, skipping or delaying Stoboclo.
              </strong>{" "}
              Talk with your doctor before starting Stoboclo treatment.
              Stopping, skipping, or delaying doses can increase your risk of
              bone fractures, especially in your spine. This risk is higher if
              you’ve already had a spine fracture. Do not change your dosing
              without consulting your doctor, who may recommend other treatments
              if Stoboclo is stopped.
            </p>
            <p>
              <strong>Serious infections.</strong> Stoboclo may increase your
              risk of serious infections in your skin, abdomen, bladder, ear, or
              heart (endocarditis). Your risk is higher if you have a weakened
              immune system or take medicines that affect immunity. You may need
              hospital treatment if an infection develops. Call your doctor
              immediately if you experience fever or chills; red, swollen, hot,
              or tender skin; persistent cough or shortness of breath; severe
              abdominal pain; or frequent, urgent, or painful urination.
            </p>
            <p>
              <strong>Skin problems.</strong> Stoboclo may cause skin problems
              like dermatitis, rash, or eczema. Call your doctor if symptoms
              such as persistent redness, dry or leathery skin, itching,
              blisters that ooze or crust, small bumps or rash patches, or skin
              peeling worsen or do not resolve.
            </p>
            <p>
              <strong>Severe bone, joint, or muscle pain.</strong> Some people
              who take denosumab products develop severe bone, joint, or muscle
              pain.
            </p>
            <p>
              <strong>Do not take Stoboclo</strong> if you have low blood
              calcium, are pregnant or planning pregnancy, or if you’re allergic
              to denosumab or any ingredients in Stoboclo.
            </p>
            <p>
              <strong>Before taking Stoboclo, tell your doctor if you:</strong>
            </p>
            <ul>
              <li>take other denosumab products</li>
              <li>have low blood calcium</li>
              <li>cannot take daily calcium and vitamin D supplements</li>
              <li>have had parathyroid or thyroid surgery</li>
              <li>have malabsorption syndrome (trouble absorbing minerals)</li>
              <li>have kidney problems or receive dialysis</li>

              <li>take medicines that can lower blood calcium</li>
              <li>plan dental surgery or tooth removal</li>
              <li>
                are pregnant, planning pregnancy, or breastfeeding. Stoboclo may
                harm an unborn baby; a pregnancy test is required before
                treatment; use effective birth control during treatment and for
                5 months after your last dose; inform your doctor immediately if
                pregnancy occurs. It is unknown if Stoboclo passes into breast
                milk; do not breastfeed during treatment.
              </li>
            </ul>
            <p>
              <p>
                <strong>
                  Tell your doctor of all medicines, vitamins, and herbal
                  supplements you take.
                </strong>{" "}
                Keep an updated list to share with healthcare providers.
              </p>

              <p>
                <strong>The most common side effects of Stoboclo are:</strong>
              </p>

              <p>
                <strong>For women with osteoporosis after menopause:</strong>{" "}
                back pain, muscle pain, pain in arms and legs, bladder
                infection, high cholesterol.
              </p>

              <p>
                <strong>For men with osteoporosis:</strong> back pain, common
                cold (runny nose or sore throat), joint pain.
              </p>

              <p>
                <strong>
                  For patients with glucocorticoid-induced osteoporosis:
                </strong>{" "}
                back pain, lung infection (bronchitis), high blood pressure,
                headache.
              </p>
              <p>
                <strong>
                  For patients treated for prostate or breast cancer:
                </strong>{" "}
                joint pain, pain in arms and legs, back pain, muscle pain.
              </p>

              <p>
                Tell your doctor if side effects are bothersome or persistent.
                These are not all possible side effects. Call your doctor for
                advice on side effects or report them to the FDA at
                1-800-FDA-1088.
              </p>
            </p>
            </div>
            <div style={{paddingRight:"40px"}}>
              <br />
              <p>
                <strong className="stoboclo-color">INDICATIONS</strong>
              </p>
              <p>
                Stoboclo (denosumab-bmwo) is a prescription medicine used to:
                <ul>
                  <li>
                    Treat osteoporosis in women after menopause who are at high
                    risk for fracture or who cannot use or haven’t responded
                    well to other osteoporosis medicines.
                  </li>
                  <li>
                    Increase bone mass in men with osteoporosis who are at high
                    risk for fracture.
                  </li>
                  <li>
                    Treat osteoporosis in men and women who will be taking
                    corticosteroid medicines (such as prednisone) for at least 6
                    months and are at high risk for fracture.
                  </li>
                  <li>
                    Treat bone loss in men who are at high risk for fracture
                    receiving certain treatments for prostate cancer that has
                    not spread to other parts of the body.
                  </li>
                  <li>
                    Treat bone loss in women who are at high risk for fracture
                    receiving certain treatments for breast cancer that has not
                    spread to other parts of the body.
                  </li>
                </ul>
                <br/>
                It is not known if Stoboclo is safe and effective in children.
                Stoboclo is not approved for use in children.
              </p>
            </div>  
          </div>        
        </Container>
      </div>
    </>
  );
};

export default StobocloHCP;
